import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarRange, Loader2, TrendingDown } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const gbp = (n) => `£${Math.round(Number(n || 0)).toLocaleString('en-GB')}`;
const day = (iso) => new Date(`${iso}T00:00:00`).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });

export const FlexDates = ({ params, currentCheapest, onPick, loading }) => {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(false);
  const [asked, setAsked] = useState(false);
  useEffect(() => { setRows(null); setErr(false); setAsked(false); }, [params]);
  const check = async () => {
    setAsked(true);
    try { const r = await axios.post(`${API_URL}/api/umrah/packages/flex`, params); setRows(r.data.dates || []); } catch { setErr(true); }
  };
  if (err) return null;
  if (!asked) return (
    <button type="button" onClick={check} className="w-full sm:w-auto rounded-full border border-orange-300 bg-orange-50 px-4 py-2 text-sm font-semibold text-slate-900 hover:bg-orange-100 flex items-center justify-center gap-2" data-testid="flex-dates-check">
      <CalendarRange className="h-4 w-4 text-[#FF6600]" />Flexible on dates? Check ±3 days for cheaper departures
    </button>
  );
  const all = rows ? [...rows, { offset: 0, departure_date: params.departure_date, available: true, cheapest_per_person: currentCheapest }].sort((a, b) => a.offset - b.offset) : null;
  const cheapest = all ? Math.min(...all.filter((r) => r.available && r.cheapest_per_person).map((r) => r.cheapest_per_person)) : null;
  return (
    <div className="rounded-xl border border-orange-200 bg-orange-50/60 p-3" data-testid="flex-dates">
      <div className="flex items-center gap-2 text-sm font-bold text-slate-900 mb-2"><CalendarRange className="h-4 w-4 text-[#FF6600]" />Flexible dates? Cheapest price per person within ±3 days</div>
      {!all ? <div className="flex items-center gap-2 text-xs text-slate-500" data-testid="flex-dates-loading"><Loader2 className="h-4 w-4 animate-spin" />Checking nearby departure dates…</div> : (
        <div className="grid grid-cols-4 sm:grid-cols-7 gap-1.5">
          {all.map((r) => {
            const cur = r.offset === 0; const best = r.available && r.cheapest_per_person === cheapest && !cur;
            const diff = r.available && currentCheapest ? r.cheapest_per_person - currentCheapest : null;
            return (
              <button key={r.departure_date} type="button" disabled={cur || !r.available || loading} onClick={() => onPick(r.departure_date)} data-testid={`flex-date-${r.offset}`}
                className={`rounded-lg border px-2 py-2 text-center transition-colors ${cur ? 'bg-slate-900 text-white border-slate-900' : !r.available ? 'bg-white text-slate-300 border-slate-200 cursor-not-allowed' : best ? 'bg-emerald-600 text-white border-emerald-600 hover:bg-emerald-700' : 'bg-white hover:border-[#FF6600] border-slate-200 text-slate-900'}`}>
                <div className="text-[11px] font-semibold">{day(r.departure_date)}</div>
                <div className="text-sm font-black">{r.available ? gbp(r.cheapest_per_person) : '—'}</div>
                {cur ? <div className="text-[10px] opacity-80">selected</div> : diff !== null && diff < 0 ? <div className="text-[10px] font-semibold flex items-center justify-center gap-0.5"><TrendingDown className="h-3 w-3" />save {gbp(-diff)}</div> : diff !== null && diff > 0 ? <div className="text-[10px] opacity-70">+{gbp(diff)}</div> : <div className="text-[10px] opacity-70">{r.available ? 'same' : 'no flights'}</div>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
